import React, { useEffect, useState } from 'react';

function AfterPay({ price, variantId, currency }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const applyAfterPayStyles = () => {
      const afterpayShadow = document.getElementById('after-pay').shadowRoot;
      const style = document.createElement('style');

      style.textContent = `
        :host {
          margin: 0;
        }

        template {
          font-size: 14px;
          position: relative;
          left: -12px;
          top: 0px;
          color: transparent;

          background-image: url('/images/info-icon.png');
          background-size: 100%;
          width: 16px;
        }

        .afterpay-paragraph {
          font-size: 14px;
          text-align: center;
          line-height: 10px;
        }

        .afterpay-logo {
          margin: 0;
        }

        .afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg {
          width: 90px !important;
          margin-left: -5px;
        }

        .afterpay-link {
          margin-left: 10px;
          font-size: 0px;
        }

        .afterpay-link:before {
          font-size: 14px;
          outline: none;
          border-bottom: 1px solid black;
          padding-bottom: 0px;
          font-family: Gotham, sans-serif;
          position: relative;
          left: -8px;
        }

        .afterpay-link {
          outline: none;
        }

        .afterpay-logo.black-on-mint .afterpay-logo-badge-background {
          fill: transparent !important;
        }

        @media only screen and (max-width: 600px) {
          .afterpay-logo.black-on-mint .afterpay-logo-badge-background {
            fill: transparent !important;
          }
        }

        @media only screen and (max-width: 1024px) {
          .afterpay-paragraph {
            font-size: 12px;
          }
        }
      `;

      afterpayShadow.append(style);
    };

    applyAfterPayStyles();
    setMounted(true);

    var checkExist = setInterval(function () {
      if (
        document.getElementById('after-pay') &&
        document.getElementById('after-pay').shadowRoot
      ) {
        applyAfterPayStyles();
        clearInterval(checkExist);
      }
    }, 100);
  }, [variantId]);

  return (
    <div className="relative mt-4">
      <afterpay-placement
        data-locale="en_US"
        data-currency={currency || 'USD'}
        data-amount={price}
        data-modal-theme="white"
        id="after-pay"
      />

      {/* Hide unstyled afterpay logo during initial load */}
      {!mounted && (
        <div className="bg-background absolute inset-0 h-full bg-white" />
      )}
    </div>
  );
}

export default AfterPay;
